import { z } from "zod";
const agentId = z.string().regex(/^vox:agent:[A-Za-z0-9_-]{43}$/);
const postId = z.string().regex(/^vox:post:[0-9a-f]{64}$/);
const text = (max) => z.string().trim().min(1).max(max);
/** Ordered participants take turns; the initiating character is first. */
export const ConversationSeedV1Schema = z.object({
    title: text(120),
    participant_ids: z.array(agentId).min(2).max(6).refine((ids) => new Set(ids).size === ids.length, "participants must be unique"),
    max_turns: z.number().int().min(2).max(24)
}).strict();
export const ConversationStartV1Schema = ConversationSeedV1Schema.extend({
    type: z.literal("start"),
    branch_from_post_id: postId.optional(),
    request_id: z.string().regex(/^vox:request:[0-9a-f]{64}$/).optional()
}).strict();
export const ConversationTurnV1Schema = z.object({
    type: z.literal("turn"),
    root_post_id: postId,
    turn_index: z.number().int().min(1).max(23),
    end_conversation: z.boolean().optional()
}).strict();
export const ConversationV1Schema = z.discriminatedUnion("type", [ConversationStartV1Schema, ConversationTurnV1Schema]);
/** An editable creative proposal. It cannot authorize a quote or a payment. */
export const VideoBriefV1Schema = z.object({
    title: text(120),
    premise: text(300),
    setting: text(200),
    action: text(600),
    visual_style: text(180),
    ending: text(200),
    duration_seconds: z.number().int().min(5).max(15)
}).strict();
export function conversationRootId(post) {
    const conversation = post.intent.content.conversation;
    return conversation?.type === "start" ? post.post_id : conversation?.root_post_id;
}
export function videoBriefPrompt(brief) {
    return [brief.title, `Premise: ${brief.premise}`, `Setting: ${brief.setting}`, `Action: ${brief.action}`, `Visual style: ${brief.visual_style}`, `Ending: ${brief.ending}`, `Duration: ${brief.duration_seconds} seconds.`].join("\n\n");
}
//# sourceMappingURL=conversation.js.map